import styled, { css } from "styled-components";

export const ToggleTrack = styled.div`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  background: #f3f1a5;
  border-radius: 999px;
  padding: 14px 16px;
`;

export const Segment = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  white-space: nowrap;
  height: 34px;
  padding: 0 16px;
  border-radius: 999px;
  font-family: var(--font-mono);
  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
  color: var(--color-primary);
  transition: background 0.2s ease-out;

  ${(props) =>
    props.isActive &&
    css`
      background: #fff;
    `}
`;
